var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"secondary-layout"},[_c('div',{staticClass:"secondary-layout__title-wrap"},[_vm._t("title")],2),_c('div',{staticClass:"secondary-layout__content-wrap"},[_c('div',{staticClass:"page-container"},[_vm._t("content")],2)]),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }